<template>
  <div class="training">
    <template v-if="!isLargeDevice">
      <h3 class="training__header" v-for="header in headers" :key="header">
        {{ header }}
      </h3>
    </template>

    <template v-for="(cert, index) in certData">
      <div
        class="training__cert"
        :key="`cert-title-${cert.displayName}-${index}`"
      >
        <check-mark
          :checked="isComplete(cert.key) || hasUnlockedSubject(cert.key)"
        />
        <div class="training__cert-title">
          <span>{{ cert.displayName }}</span>
          <span
            class="training__status"
            :class="{
              'training__status--completed': isComplete(cert.key),
              'training__status--unlocked': hasUnlockedSubject(cert.key),
            }"
            >{{ progressStatus(cert.key) }}</span
          >
        </div>
      </div>

      <div
        :key="`subjects-${cert.displayName}-${index}`"
        class="training__subjects-unlocked"
      >
        <span
          v-if="isLargeDevice"
          class="training__subjects-unlocked--mobile"
          >{{ $t('subjectCertsDropDown.subjectsUnlocked') }}</span
        >
        <span
          v-for="subject in cert.subjectsIncluded"
          :key="subject.displayName"
          class="training__subjects-unlocked--subject"
          >{{ subject.displayName }}</span
        >
      </div>

      <div class="action-btns" :key="`action-btns-${index}`">
        <router-link
          :to="`/${certReviewLink(cert.key)}`"
          class="action-btns__review-link"
        >
          <span class="action-btns__review-link--text">{{
            $t('general.review')
          }}</span>
          <arrow-right-icon
            v-if="dir == 'ltr'"
            class="action-btns__review-link--arrow-icon"
          />
          <arrow-left-icon
            v-else-if="dir == 'rtl'"
            class="action-btns__review-link--arrow-icon"
          />
        </router-link>

        <large-button
          primary
          :showArrow="false"
          :routeTo="
            !isComplete(cert.key) || hasUnlockedSubject(cert.key)
              ? certQuizLink(cert.key)
              : null
          "
          class="action-btns__quiz-btn"
          :disabled="isComplete(cert.key)"
        >
          <span>{{ actionButtonText(cert.key) }}</span>
        </large-button>
      </div>

      <div
        :key="`border-${cert.displayName}-${index}`"
        class="training__row-border"
      />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Case from 'case'
import CheckMark from '@/components/CheckMark.vue'
import LargeButton from '@/components/LargeButton.vue'
import ArrowLeftIcon from '@/assets/left-arrow.svg'
import ArrowRightIcon from '@/assets/arrow.svg'

export default {
  name: 'SubjectCertsDropDown',
  components: {
    CheckMark,
    LargeButton,
    ArrowLeftIcon,
    ArrowRightIcon,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    certData: {
      type: Array,
      required: true,
    },
    trainingCourse: {
      type: Boolean,
    },
  },

  computed: {
    ...mapState({
      user: state => state.user.user,
      windowWidth: state => state.app.windowWidth,
    }),
    ...mapGetters({
      dir: 'app/direction',
    }),
    isLargeDevice() {
      const largeScreenBreakpoint = 992

      return this.windowWidth <= largeScreenBreakpoint
    },
  },

  methods: {
    isComplete(cert) {
      return this.user.certifications[cert].passed
    },
    hasUnlockedSubject(cert) {
      return this.user.subjects.includes(cert)
    },
    certReviewLink(cert) {
      return `/${this.$i18n.locale}/training/review/${Case.kebab(cert)}`
    },
    certQuizLink(cert) {
      return `/${this.$i18n.locale}/training/${Case.kebab(cert)}/quiz`
    },
    progressStatus(cert) {
      if (this.isComplete(cert))
        return this.$root.$t('subjectCertsDropDown.progressStatus.isComplete')
      if (this.hasUnlockedSubject(cert))
        return this.$root.$t(
          'subjectCertsDropDown.progressStatus.hasUnlockedSubject'
        )
      else return this.$root.$t('subjectCertsDropDown.progressStatus.other')
    },
    actionButtonText(cert) {
      if (this.isComplete(cert))
        return this.$root.$t('subjectCertsDropDown.progressStatus.isComplete')
      else return this.$root.$t('subjectCertsDropDown.progressStatus.other')
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}
</style>
